export const isHeaderTag = (node: Node) => {    
  return node.nodeName?.match(/^H[2-6]$/);
}